import { Inject, Injectable } from '@angular/core';
import { IFullscreenPreviewModalService } from "./i-fullscreen-preview-modal.service";
import { FullscreenPreviewModalComponent } from "./fullscreen-preview-modal.component";
import { IModalService, modalServiceInjectionToken } from '@zaeper/angular-dashboard-view-lib';
import { sessionStateServiceInjectionToken } from "../../global-states/session/session-state-service-injection-token";
import { ISessionStateService } from "../../global-states/session/i-session-state.service";

@Injectable()
export class FullscreenPreviewModalService implements IFullscreenPreviewModalService {
  constructor(
    @Inject(modalServiceInjectionToken) private readonly _modalService: IModalService,
    @Inject(sessionStateServiceInjectionToken) private readonly _sessionStateService: ISessionStateService
  ) {
  }

  open(): void {
    const receiver = this._sessionStateService.getActiveReceiver();
    const aspectRatio = receiver?.resolutionX && receiver?.resolutionY 
      ? receiver.resolutionX / receiver.resolutionY 
      : 16 / 9;
    
    // Calculate width based on 100vh and aspect ratio
    const viewportHeight = window.innerHeight;
    const modalWidth = Math.round(viewportHeight * aspectRatio);

    this._modalService.open(FullscreenPreviewModalComponent, {
      styleClass: 'fullscreen-preview-modal',
      showHeader: false,
      closable: true,
      closeOnEscape: true,
      dismissableMask: true,
      width: `${modalWidth}px`,
      height: '100vh'
    });
  }
}
